import { squads } from '../../../utils/layoutConfig';
import { FormControl, FormLabel, Select } from '@chakra-ui/react';

function setProjectSquad({ e, projectInfo, setProjectInfo, setSquadValid }) {
	setSquadValid(true);
	const value = e.target.value;
	const newProjectInfo = { ...projectInfo };
	newProjectInfo.squad = value;
	setProjectInfo(newProjectInfo);
}

const CreateSaveProjectSquad = ({ projectInfo, setProjectInfo, squadValid, setSquadValid }) => {
	return (
		<FormControl maxW="50%" mb={6}>
			<FormLabel fontWeight="bold" fontSize={'xs'}>
				Squad responsável
			</FormLabel>
			<Select
				defaultValue={projectInfo.squad ? projectInfo.squad : ''}
				isInvalid={!squadValid}
				onChange={(e) => setProjectSquad({ e, projectInfo, setProjectInfo, setSquadValid })}
				size="sm"
				h={8}
			>
				<option key={-1} value="" disabled hidden>
					Escolha um squad
				</option>
				{squads &&
					squads.map((squad, index) => (
						<option key={index} value={squad.value}>
							{squad.name}
						</option>
					))}
			</Select>
		</FormControl>
	);
};

export default CreateSaveProjectSquad;
